// extracted by mini-css-extract-plugin
export default {"backbutton":"profileHeader_backbutton__O-K4q"};